import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {getIngestList, restartIngest} from '@pluto/rest';
import {setNotificationAction as setNotification} from '@pluto/notification';

export const INGEST_LIST_SET = 'INGEST_LIST_SET';

export const setIngestListAction = createAction(INGEST_LIST_SET, async (params: {[key: string]: string}) => {
    return await getIngestList(params);
});

export const restartIngestTaskAfterEditingAction = curry(async (id: number, dispatch) => {
    const [error] = await tryToCatch(restartIngest, id);

    if (!error) {
        dispatch(
            setNotification({
                type: 'success',
                text: 'Ingest session restarted after editing',
            })
        );
    } else {
        const {data: errorData} = error.response;

        dispatch(
            setNotification({
                type: 'error',
                text: errorData.message,
            })
        );
    }
});

export const restartIngestTaskAction = curry(async (id: number, params: {[key: string]: string}, dispatch) => {
    const [error] = await tryToCatch(restartIngest, id);

    if (!error) {
        dispatch(
            setNotification({
                type: 'success',
                text: 'Ingest session restarted',
            })
        );

        dispatch(setIngestListAction(params));
    } else {
        const {data: errorData} = error.response;

        dispatch(
            setNotification({
                type: 'error',
                text: errorData.message,
            })
        );
    }
});
